import { Card, Grid } from '@mantine/core';
import LineChart from '../../components/Charts/LineChart';
import ProductStatsCard from '../../components/Products/ProductStatsCard';
import Spinner from '../../components/Spinner';

const ProductInteractionsTab = ({ histogram, stats }) => {
  return (
    <Card withBorder>
      <Grid>
        <Grid.Col span={12}>
          {histogram && stats ? (
            <LineChart data={histogram} title="Product Interactions">
              <ProductStatsCard stats={stats} />
            </LineChart>
          ) : (
            <Spinner ta="center" />
          )}
        </Grid.Col>
      </Grid>
    </Card>
  );
};

export default ProductInteractionsTab;
